import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

interface ProtectedAdminRouteProps {
    children: React.ReactNode;
}

const ProtectedAdminRoute: React.FC<ProtectedAdminRouteProps> = ({ children }) => {
    const { token, isAdmin } = useContext(AuthContext);
    const [isChecking, setIsChecking] = useState(true);
    
    useEffect(() => {
        // Short delay to ensure authentication state is fully processed
        const timer = setTimeout(() => {
            setIsChecking(false);
        }, 100);
        
        return () => clearTimeout(timer);
    }, [token, isAdmin]);
    
    // Show nothing while checking
    if (isChecking) {
        return <div>Checking authentication...</div>;
    }
    
    // If not authenticated or not an admin, redirect to login
    if (!token || !isAdmin) {
        return <Navigate to="/admin/login" replace />;
    }
    
    // Otherwise, render the protected content
    return <>{children}</>;
};

export default ProtectedAdminRoute;